import * as React from "react";
import * as ReactDOM from "react-dom";
import GuitarTab from "./GuitarTab";

declare global {
    interface Window {
        app: any;
    }
}

export default class GuitarChords extends React.Component<any, any> {
    constructor(props : any) {
        super(props);

        this.state = Object.assign({}, Object.keys(props).length > 0 ? this.props : window.initialState);
    }

    render() {
        let appCols = null
        if(this.state.apps.length > 0)
            appCols = this.state.apps.map((app, i) =>
                <div className="col-md-4 col-sm-6 col-xs-12" key={i}>
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <GuitarTab app={app} config={this.state} />
                        </div>
                    </div>
                </div>
            );
        else
            appCols = <div>
                Sorry but we can't find any chords. Feel free to contact us if you think that it's a bug: <a href="https://forums.songtive.com">forums.songtive.com</a>
            </div>;



        return <div className="row">
                {appCols}
            </div>;
    }
}



// WEBPACK FOOTER //
// ./components/guitar/GuitarChords.tsx